<div class="background" [style.background]="isNeutralBackground ? '#ffffff' : backgroundstyle">

  <ng-sidebar-container>

    <!-- help sidebar -->
    <ng-sidebar *ngIf="isloggedin" position="right" [(opened)]="helpSidebarOpened" [animate]="false">
      <app-helpview (closeHelpSidebar)="closeHelpSidebar()" [helpId]="helpId"></app-helpview>
    </ng-sidebar>

    <!-- main wrapper -->
    <div id='adminContent' #adminContent ng-sidebar-content>

      <!-- header (only when logged-in) -->
      <app-header *ngIf="isloggedin" (toggleSidebar)="toggleSidebar()" (closeHelpSidebar)="closeHelpSidebar()"
                  (toggleOrderlist)="toggleOrderlist()" (onHeaderReady)="onHeaderReady()"></app-header>

      <!-- main content -->
      <main #main *ngIf="isReady">

        <router-outlet></router-outlet>

        <!-- TODO: move login box in dedicated component -->

        <!-- login box (only when logged-out) -->
        <ng-container *ngIf="!isloggedin && this.router.url === '/'">
          <div class="container py-5 fixed-bottom mb-5">
            <div class="row">
              <div class="col-md-12">

                <div class="row">
                  <div class="col-6 col-lg-4 me-auto ms-0" *ngIf="isMaintenanteMode()">
                    <div class="alert alert-info mt-3" role="alert"
                         [innerHTML]="siteinfo.maintenance_mode['maintenance_msg']">
                    </div>
                  </div>
                </div>

                <div *ngIf="isBielBienne()" class="row mb-5">
                  <div class="col-md-6 col-lg-4 me-auto ms-0 ">
                    <div class="card rounded holder">
                      <div class="card-body">
                        <div class="w-100 mb-3 small">
                          <h6>S’inscrire pour ouvrir un compte</h6>
                          <p>
                            L'accès au Printshop vous permet de transmettre facilement et rapidement toutes vos commandes d'impression de documents.
                          </p>
                          <p>
                            Veuillez transmettre votre demande d’ouverture de compte  l’adresse mail suivante : <a href="mailto:logistique@biel-bienne.ch">logistique@biel-bienne.ch</a>
                          </p>
                          <hr/>
                          <h6>Sich registrieren, um ein Konto zu eröffnen</h6>
                          <p>Der Zugang zum Printshop bietet Ihnen die Möglichkeit, alle Ihre Druckaufträge für Dokumente einfach und schnell zu übermitteln.
                          </p>
                          <p>
                          Bitte senden Sie Ihren Kontoeröffnungsantrag an folgende E-Mail-Adresse: <a href="mailto:logistique@biel-bienne.ch">logistique@biel-bienne.ch</a>
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-lg-4 me-auto ms-0 ">
                    <div class="card rounded holder">
                      <div class="card-body">
                        <div class="w-100 text-center mb-3">
                          <ng-container *ngIf="siteinfo">
                            <img class="brand-login" alt="" [src]="siteinfo.frontlogouri"/>
                          </ng-container>
                        </div>
                        <h4 class="text-dark mb-3">Login</h4>
                        <alert *ngIf="loginError" type="danger">
                          {{loginError}}
                        </alert>
                        <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
                          <div class="mb-3">
                            <label for="username" class="form-label visually-hidden">Username</label>
                            <input class="form-control"
                                   [ngClass]="{'is-invalid':submittedLoginForm && f.username.errors}"
                                   type="text" id="username"
                                   formControlName="username" placeholder="Username or e-mail" aria-label="" autofocus/>
                          </div>
                          <div class="mb-3">
                            <label for="username" class="form-label visually-hidden">Username</label>
                            <input class="form-control"
                                   [ngClass]="{'is-invalid':submittedLoginForm && f.password.errors}"
                                   type="password" id="password"
                                   formControlName="password" placeholder="Password" aria-label=""/>
                          </div>
                          <div class="d-grid">
                            <button [disabled]="isAuthenticating" type="submit" class="btn btn-primary">Sign in</button>
<!--                            <a [routerLink]="['/password/forgot']"-->
<!--                               class="mt-2 d-block w-100 text-end text-muted"><small>Forgot your password?</small></a>-->
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </ng-container>

      </main>

      <!-- orderlist popover -->
      <div class="orderlist-container" *ngIf="orderListOpened && isloggedin">
        <app-orderview (toggleOrderlist)="toggleOrderlist()"></app-orderview>
      </div>

    </div>

  </ng-sidebar-container>

</div>
